module.exports = __webpack_public_path__ + "fonts/TTNormsPro-Thin.1a7e0993.woff";